import { Outlet } from 'react-router';

import DashboardButtons from '@/features/DashboardButtons';
import Header from '@/layout/Header/Header';
import MainContent from '@/layout/MainContent';

import { DashboardTabs } from './DashboardTabs';

const Dashboard = () => {
  return (
    <>
      <Header title="Dashboard" actions={<DashboardButtons />} actionsNewLine>
        <DashboardTabs />
      </Header>
      <MainContent>
        <Outlet />
      </MainContent>
    </>
  );
};

export default Dashboard;
